import { useParams } from "react-router-dom";
const useCustomParams = (key?: any) => {
    const params = useParams();

    if (key) {
        return params[key]
    }

    return params;
}
export default useCustomParams;